import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { HeaderSub } from '../../Common/HeaderSub'
import { LiveChatDig } from './LiveChatDig';
import { LiveChatGoods } from './LiveChatGoods';
import { LiveChatOrder } from './LiveChatOrder';
import { GoodsDtl } from '../../Goods/GoodsMgr/GoodsDtl';

/* 개발담당:양유빈
 * 화면기능:라이브챗 Index
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.LiveChatDig,  //기본 컴포넌트 할당
            ContentState: null
        };
        const Param_Uid = Big3Common.Util.GetParams("union_uid");
        this.state.ContentState = { Union_Uid: Param_Uid };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "LiveChatDig": "LiveChatDig",
        "LiveChatGoods": "LiveChatGoods",
        "LiveChatOrder": "LiveChatOrder",
        "GoodsDtl":"GoodsDtl"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    } 

    render() {
        if (this.state.RenderName === this.CompName.LiveChatDig) {
            //소매 리스트(문의가 1번이상있는 소매)
            return (
                <div>
                    <HeaderSub
                        HeaderTitle=""
                        HistoryBack={true}
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                    <LiveChatDig
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.LiveChatGoods) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="상품목록"
                        ComponentUrl="LiveChatDig"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <LiveChatGoods
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.LiveChatOrder) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="주문목록"
                        ComponentUrl="LiveChatDig"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <LiveChatOrder
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="제품상세"
                        ComponentUrl="LiveChatDig"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <GoodsDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />

                </div>
            );
        }
    }
}
